
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/security-policy",
      function () {
        return require("private-next-pages/legal/security-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/security-policy"])
      });
    }
  